import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const selectors = {
	section: ".js-sticky-section",
	sectionInner: ".js-sticky-section-inner",
	expertiseList: ".js-expertise-scroller",
	scrollArea: ".js-expertise-scroller__scroll-area",
	overlay: ".js-expertise-scroller-overlay",
};

var module = {
	_init: function () {
		this.section = document.querySelector(selectors.section);
		this.expertiseList = document.querySelector(selectors.expertiseList);
		this.scrollArea = document.querySelector(selectors.scrollArea);
		this.overlay = document.querySelector(selectors.overlay);
		this._initiateScrollTrigger();

		if (this.section && this.expertiseList && this.scrollArea && this.overlay) {
		} else {
			//console.warn("Required elements are missing");
			return;
		}
	},

	_initiateScrollTrigger: function () {
		const overlay = this.overlay;

		let timeline = gsap.timeline({
			scrollTrigger: {
				trigger: this.section,
				scrub: true,
				pin: true,
				start: "top top",
				end: "bottom top",
				markers: false,
				invalidateOnRefresh: true,
				onUpdate: (self) => {
					// Show overlay when scrolling up
					if (self.direction === -1 && self.progress < 1) {
						if (overlay.style.display === "none") {
							overlay.style.display = "block";
						}
					}
				}
			}
		});

		timeline.to(this.expertiseList, {
			y: () => `${this.scrollArea.offsetHeight}`,
			yPercent: -100
		});

		timeline.from(this.sectionInner, {
			maxWidth: "70%",
			transformOrigin: "center center",
			ease: "none"
		}, '<');

		// Fade out overlay only once
		timeline.to(this.overlay, {
			opacity: 0,
			ease: "linear",
			onComplete: () => {
				overlay.style.display = "none";
			}
		}, 0);
	}

};

export { module as initScrollEffects };

